import { createSlice } from '@reduxjs/toolkit';
import { getUserDetailAction } from './userDetailAction';
import { createUser } from '../createUser/createUserAction';

export const userDetailSlice = createSlice({
  name: 'userDetail',
  initialState: {
    loading: false,
    data: {},
    message: '',
    error: null,
    needsRefresh: false,
  },
  reducers: {
    clearRefreshFlag: (state) => {
      state.needsRefresh = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserDetailAction.pending, (state) => {
      state.loading = true;
      state.needsRefresh = false; // Clear flag when starting refresh
    });
    builder.addCase(getUserDetailAction.fulfilled, (state, { payload }) => {      
      state.loading = false;
      state.data = payload.data;
      state.message = payload.message;
      state.error = null;
      state.needsRefresh = false;
    });
    builder.addCase(getUserDetailAction.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || 'An error occurred';
      state.needsRefresh = false;
    });
    // Listen for createUser success to trigger refresh
    builder.addCase(createUser.fulfilled, (state) => {
      // Mark that we need to refresh user data
      state.needsRefresh = true;
    });
  },
});

export const { clearRefreshFlag } = userDetailSlice.actions;
